module.exports = __webpack_public_path__ + "img/horizontal_3_3_6005.fb5973e4.png";